import { timeStringToMinutes } from './dateTimeFormat';

export function getDiffFromNow(value: string) {
  const providedDate = new Date(value);
  const currentDate = new Date();
  const diffInMilliseconds = currentDate.getTime() - providedDate.getTime();

  const diffInMinutes = Math.floor(diffInMilliseconds / (1000 * 60));
  const diffInSeconds = Math.floor(diffInMilliseconds / 1000);
  const diffInHours = Math.floor(diffInMilliseconds / (1000 * 60 * 60));

  return {
    min: diffInMinutes,
    sec: diffInSeconds,
    hours: diffInHours,
  };
}

export function isOpenBeforeCloseTime(startTime: string, endTime: string) {
  const today = new Date().toISOString().split('T')[0];
  const start = new Date(`${today}T${startTime}:00`);
  const end = new Date(`${today}T${endTime}:00`);

  return start < end;
}

/**
 * Checks if two time intervals overlap.
 * The first interval is represented by `left_start` and `left_end`.
 * The second interval is represented by `right_start` and `right_end`.
 * Returns `true` if there is any overlap between the two intervals.
 *
 * @param {string} left_start - The start time of the first interval (in "HH:MM" format).
 * @param {string} left_end - The end time of the first interval (in "HH:MM" format).
 * @param {string} right_start - The start time of the second interval (in "HH:MM" format).
 * @param {string} right_end - The end time of the second interval (in "HH:MM" format).
 * @returns {boolean} `true` if the intervals overlap, otherwise `false`.
 */
export function isTimeOverlap(
  left_start: string,
  left_end: string,
  right_start: string,
  right_end: string,
): boolean {
  const leftStartMinutes = timeStringToMinutes(left_start);
  const leftEndMinutes = timeStringToMinutes(left_end);
  const rightStartMinutes = timeStringToMinutes(right_start);
  const rightEndMinutes = timeStringToMinutes(right_end);

  return (
    leftStartMinutes < rightEndMinutes && leftEndMinutes > rightStartMinutes
  );
}
